import {useEffect} from "react";

import {SwapWidgetSearchParamKey} from "../core/widgetTypes";
import {WalletType} from "../wallet/util/walletTypes";
import {algod} from "../core/integrations/algosdk/AlgodManager";
import {mapAccountsToAppStateAccounts} from "../wallet/util/walletUtils";
import {useWalletContextDispatch} from "../wallet/util/context/WalletContext.utils";
import useDisconnectAccount from "../wallet/account/useDisconnectAccount";

/**
 * This hook is responsible for fetching the signer data and updating the state,
 * for the case where user wants to use the parent signer.
 */
export function useSignerData() {
  /**
   * TODO: Finally, we should move this logic into WalletContext,
   * probably no need for extra hook
   */
  const searchParams = new URLSearchParams(document.location.search);
  const useParentSigner = searchParams.get(SwapWidgetSearchParamKey.USE_PARENT_SIGNER);
  const addressFromUrl = searchParams.get(SwapWidgetSearchParamKey.ACCOUNT_ADDRESS);
  const disconnectAccount = useDisconnectAccount();
  const dispatchWalletContextAction = useWalletContextDispatch();

  useEffect(() => {
    const shouldUseParentSigner = useParentSigner === "true";

    /**
     * When there is a change in the useParentSigner param,
     * we should reflect the new value in the wallet context
     */
    if (shouldUseParentSigner) {
      // Try to disconnect the current account to avoid data mismatch
      disconnectAccount();

      dispatchWalletContextAction({
        type: "SET_WALLET_TYPE",
        walletType: WalletType.ParentSigner
      });

      if (addressFromUrl) {
        (async () => {
          const walletAccounts = await Promise.all(
            [addressFromUrl].map((address) =>
              algod.client.accountInformation(address).do()
            )
          );
          const finalAccountsData = await mapAccountsToAppStateAccounts(walletAccounts);

          dispatchWalletContextAction({
            type: "SET_WALLET_AND_ACCOUNTS",
            accounts: finalAccountsData,
            walletType: WalletType.ParentSigner,
            selectedAccount: finalAccountsData[0]
          });
        })();
      }
    }
  }, [addressFromUrl, disconnectAccount, dispatchWalletContextAction, useParentSigner]);
}
